import { useCallback } from 'react'
import { useToast } from '@chakra-ui/react'

/**
 * エラートースト表示フック
 * @returns {Function} showError - エラー情報を受け取りトーストを表示する関数
 */
export const useErrorToast = () => {
  const toast = useToast()

  const showError = useCallback(
    ({ title, errorMessage, duration = 5000 }) => {
      toast({
        title,
        description: errorMessage,
        status: 'error',
        duration,
        isClosable: true,
      })
    },
    [toast],
  )

  return { showError }
}
